module.exports = {
  "id": "effects",
  "title": "effects",
  "category": "style",
  "color": "purple",
  "info": [
    {
      "text": "Apply visual effects to a piece",
      "image": "provision/glitches/effects/effects.gif"
    }
  ],
  "icon": "paint",
  "searchTags": ["visual","looks","color","style"],
  "exposedVariables": [],
  "codeImage": "provision/glitches/effects/effects.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/effects/effects.svg"
};